import styled from 'styled-components'
import { v1 as color, contentLevels, media } from 'sidecar-design-library'

export const InputAddress = styled.div`
  position: relative;
`

export const AutocompleteList = styled.ul`
  margin: 0;
  padding: 0;
  position: absolute;
  list-style: none;
  z-index: ${contentLevels.components + 4};
  top: 3.75rem;
  left: 0;
  width: 100%;
  border: solid 1px ${color.SILVER};
  border-top: 0;
  max-height: 18.75rem;
  overflow: auto;
  background: #fff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
`

export const AutocompleteItem = styled.li`
  padding: 1.25rem;
  border-bottom: solid 1px ${color.STONE};
  color: ${color.GREY};
  font-size: 0.875rem;

  & strong {
    font-size: 1.125rem;
    color: ${color.AQUAMARINE};
  }

  &:hover {
    background: ${color.AQUA_OVERLAY};

    & strong {
      color: ${color.SCOOTER};
    }
  }

  ${media.mobileAndBelow`
    & strong,
    & span {
      display: block;
      width: 100%;
      line-height: 1.25rem;
    }
  `}
`
